import { useEffect, useState } from 'react'
import { startCase } from 'lodash'

import redirects from '../../redirects.json'
import seoData from 'page-components/index/seo'

const useMetadata = (path, opts = {}) => {
  const [metadata, setMetadata] = useState(null)

  useEffect(() => {
    if (!path) return
    if (opts.byPassMetadata) return
    const fetchMetadata = async () => {
      let to = path
      const redirect = redirects.find((r) => r.from === path)
      if (redirect) to = redirect.to
      try {
        const response = await fetch(to.split('#')[0])
        if (!response.ok) {
          throw new Error('Not Found')
        }
        const html = await response.text()
        const metaTagRegex = /<meta[^>]*>/g
        const metaTags = html.match(metaTagRegex)

        let imageData, title, description
        let tag = 'Resource'
        if (to.includes('/docs/')) tag = 'Documentation'
        else if (to.includes('/products/')) tag = 'Product'

        if (metaTags) {
          metaTags.forEach((meta) => {
            const content = /content="([^"]*)"/.exec(meta)
            const property = /property="([^"]*)"/.exec(meta)
            const name = /name="([^"]*)"/.exec(meta)
            if (property && content) {
              if (property[0] === 'property="og:image"') {
                imageData = content[0].split('"')[1]
              }
              if (property[0] === 'property="og:title"') {
                title = content[0].split('"')[1]
              }
              if (property[0] === 'property="twitter:title"' && !title) {
                title = content[0].split('"')[1]
              }
              if (property[0] === 'property="twitter:image"' && !imageData) {
                imageData = content[0].split('"')[1]
              }
            }
            if (name && content) {
              if (name[0] === 'name="description"') {
                description = content[0].split('"')[1]
              }
            }
          })
        }
        setMetadata({ title, imageData, tag, to, description })
      } catch {
        setMetadata({
          title: startCase(path),
          tag: 'Resource',
          to,
          description: seoData.description,
        })
      }
    }
    fetchMetadata()
  }, [path])

  return metadata
}

export default useMetadata
